module.exports = __webpack_public_path__ + "static/media/1roup 2@3x@3x copy.f2bf55e5.png";